<template>
    <div id="container">
        <div class="doctor-info">
            <div>
                <img :src="doctorInfo.pic_Url" :onerror="defaultImg">
            </div>
            <div>
                <div>{{doctorInfo.name}}&ensp;<span>{{doctorInfo.job_Title}}</span></div>
                <div>{{doctorInfo.hosp_Info}}|{{doctorInfo.dept_Info}}</div>
            </div>
        </div>
        <div class="article_views">
            <ul>
                <li @click="share">
                    <img src="../assets/image/41.png"/>
                    <span>分享</span>
                </li>
                <li>
                    <img src="../assets/image/42.png"/>
                    <span>0</span>
                </li>
                <li>
                    <img src="../assets/image/43.png"/>
                    <span>0</span>
                </li>
            </ul>
        </div>
        <div class="title">{{article.title_Txt}}</div>
        <div class="article-content">
            <p v-html="article.content_Txt"></p>
            <img :src="article.content_Url" v-if="article.content_Url != null"/>
        </div>
        <div class="masking" v-if="masking">
            <img class="point" src="../assets/image/point.png"/>
            <div class="tips">
                请点击小程序右上角
                <img src="../assets/image/etc.png" alt="">发送给朋友
                <div class="know" @click="closeMasking">我知道啦</div>
            </div>
        </div>
        <!--<div class="department">{{doctorInfo.hosp_Info}}</div>
        <div class="view-info">
          <p>{{article.read_Count}}</p>
          <img src="./assets/image/icon-view.png">
        </div>-->
    </div>
</template>

<script>
    export default {
        name: "detail",
        data() {
            return {
                defaultImg:'this.src="' + require('../assets/image/image-orange.png') + '"',
                article: {
                    content_Txt: '',
                },
                doctorInfo:'',
                masking:false
            }
        },
        mounted () {
            //let articleId = '78d55d6615cc4dd8864efedd275b2adf';
            this.getData(this.$route.params.id)
        },
        methods: {
            share(){
                this.masking = true
            },
            closeMasking(){
                this.masking = false
            },
            getData(articleId){
                this.$axios({
                    method: 'post',
                    url: 'https://xcx.judeng.net/wxminiapp/webApi/article/'+ articleId +'/get.json',
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'Accept': '*/*'
                    }
                }).then((response) => {
                    console.log(response)
                    if(response.data.status === 200){
                        let article  = response.data.object.article
                        if(article.content_Txt) article.content_Txt = article.content_Txt.replace(/\n/g,'<br>')
                        this.article = article
                        this.doctorInfo = response.data.object.doctorInfo
                        if (this.article && this.article.link_Url) {
                            window.location.href=this.article.link_Url;
                        }
                    }
                }).catch((error) => {
                    console.log(error)
                })
            }
        }
    }
</script>

<style scoped>

</style>
